const defaultState = {}

const menus = (state = defaultState, action) => {
  switch (action.type) {
    case 'MENUS_ADD':
      return {
        ...state,
        ...action.data
      }
    default:
      return state
  }
}

export default menus



// WEBPACK FOOTER //
// ./src/reducers/menus.js